import styled from 'styled-components';

const CenteringDiv = styled.div`
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
`;

export default CenteringDiv;
